/* eslint-disable sort-keys */
import { createSelector } from 'reselect';
import {
  activatedDevices, totalDatapoints,contractTotalDatapointsTransactions, devicesOnlineToday
} from '../../services/reportsservice';
import { stringToNumberLocale } from '../../helpers/formatter';
import { EMPTY_OBJ } from '../../constants';
import {t} from "i18next";
import {getReportData} from "../../helpers/utils";

export const filterSelector = createSelector(state => state, (reduxState) => {
  // these should really be set in default reducers
  const activatedDevicesAlias = reduxState.reportsData[activatedDevices().alias] || EMPTY_OBJ;
  const totalDatapointsAlias = reduxState.reportsData[totalDatapoints().alias] || EMPTY_OBJ;
  const devicesOnlineTodayAlias = reduxState.reportsData[devicesOnlineToday().alias] || EMPTY_OBJ;
  const contractTotalDatapointAlias = reduxState.reportsData[contractTotalDatapointsTransactions().alias] || EMPTY_OBJ;
  const activatedDevicesAliasData = activatedDevicesAlias.data;
  const totalDatapointsAliasData = getReportData(totalDatapointsAlias.data, 'Datapoint_Transmissions', 'stringToNumberLocale');
  const contractTotalDatapointAliasData = getReportData(contractTotalDatapointAlias.data, 'Contract_Metering_Datapoint_Transactions');
  const devicesOnlineTodayAliasData = devicesOnlineTodayAlias.data;
  const devicesOnlineTodayLocale = getReportData(devicesOnlineTodayAliasData, 'Devices_Online_Today', 'stringToNumberLocale');
  const activatedDevicesLocale = getReportData(activatedDevicesAliasData, 'Activated_Devices', 'stringToNumberLocale');


  const getData = (value, details = null) => (details ? {
    details,
    value,
  } : {
    value
  }
  );

  const getTxDatapoints = () => {
    if (reduxState.isMeteringApi) {
      const txDatapoint = (contractTotalDatapointAliasData === t('unableToFetchData'))
        ? t('unableToFetchData')
        : (contractTotalDatapointAliasData)
          ? stringToNumberLocale(contractTotalDatapointAliasData.total_datapoint)
          : null;

      return getData(txDatapoint);
    } else {
      return getData(totalDatapointsAliasData);
    }
  };

  return {
    ...reduxState,
    defaultReports: {
      'devices.online': getData(devicesOnlineTodayLocale),
      'devices.activated': getData(activatedDevicesLocale),
      'datapoints.txdatapoints': getTxDatapoints()
    }
  };
});
